<template>
  <fb-form-properties-manager id="patient-treatment-events-v1-properties-yelb8b" :fields="fields" :formId="formId" />
</template>

<script>
export default {
  name: "EmarPatientVitalsV1Properties",
  props: ["formId"],
  data() {
    return {
      fields: [
        {
          type: "dropdown",
          properties: {
            label: "Filter by Date",
            options: [
              {
                value: "currentday",
                text: "Current Day"
              },
              {
                value: "last7days",
                text: "Last 7 Days"
              },
              {
                value: "last30days",
                text: "Last 30 Days"
              },
              {
                value: "last3months",
                text: "Last 3 Months"
              }
            ]
          },
          property: "dateFilter",
          defaultValue: "currentday"
        },
        {
          type: "conditionEditor",
          properties: {
            label: "Visibility condition",
            updateValueMiddleware: (value) => {return value.replace("{{(","{{!(")}
          },
          property: "hidden"   
        }
      ]
    };
  }
};
</script>

<style></style>

